"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// const baseUrl = 'http://localhost:1002/';
var baseUrl = '/tools';
exports.SEND_SERVICE_MAIL_API = baseUrl + "/mail/promediatek/send";
